export function validateMfeRetracement(data) {
  if (Number(data.activationValue) <= 0)
    return [false, 'Activation Amount must be larger than 0.'];
  if (Number(data.retracePct) <= 0)
    return [false, 'Retrace Percentage must be larger than 0.'];
  return [true, ''];
}
